export enum DeviceType {
    UNKNOWN = 'UNKNOWN',
    GRIP = 'GRIP',
    MUSCLE_TESTER = 'MUSCLE_TESTER',
    PLATES = 'PLATES',
    SENS = 'SENS',
    BUBBLE = 'BUBBLE',
    LINK = 'LINK',
    HEXAS = 'HEXAS',
    EMG = 'EMG',
    KPOWER = 'KPOWER',
    DELTAS_3D = 'DELTAS_3D'
}

export class DeviceTypes {
    /**
     * Returns all except UNKNOWN
     */
    public static all(): DeviceType[] {
        return [DeviceType.GRIP, DeviceType.MUSCLE_TESTER, DeviceType.PLATES,
            DeviceType.SENS, DeviceType.BUBBLE, DeviceType.LINK, DeviceType.HEXAS,
        DeviceType.EMG, DeviceType.KPOWER, DeviceType.DELTAS_3D];
    }

    public static parse(device: string): DeviceType {
        return DeviceType[device as keyof typeof DeviceType];
    }
}
